import CollapsibleContent from './CollapsibleContent';
import CollapsibleContentFull from './CollapsibleContentFull';
import CollapsibleContentIntro from './CollapsibleContentIntro';

export default CollapsibleContent;
export { CollapsibleContent, CollapsibleContentIntro, CollapsibleContentFull };
